
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Натисніть «Відкрити у браузері…»`,
's182ab2d6c997515f': `Додайте на Домашній екран для зручного доступу та ширших можливостей.`,
's224cbcec014ef6b5': `Натиснути «Поділитися»`,
's233af3b7eb5e0364': `Додати ярлик на телефон`,
's37a9e8aec5713460': `Детальніше`,
's4c3161035f3a1413': `Натисніть «Меню»`,
's4e1e10a6ca408245': `Натиснути «На Початковий экран»`,
's6196153c4b0c1ea0': `Встановити`,
's633502f7cff4f847': `Відкрити меню браузера`,
's681e399d63311fba': `Показати галерею`,
's6d14a4f70ba4e3cf': `Натисніть «Меню», якщо немає значка «Поділитися»`,
's922329d6f6213590': `Додати на Dock`,
's9c63a79ffcc2a3a3': `Натисніть «На початковий екран»`,
'sa2d71bfd9525168d': `Натисніть «Додати на Dock»`,
'sa5ef80b4bb9b39f8': `Згорнути`,
'sb527eca1c1d7e7be': `Відкрийте меню вбудованого браузера`,
'sba52286c21552a4e': `Встановіть на ваш пристрій для зручного доступу та ширших можливостей.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `На Початковий экран`,
'sd18a5b85f599ff3c': `Відкрийте скопійоване посилання в Safari`,
'se72fc3a84f9b51c3': `Натисніть, щоб скопіювати посилання`,
'se740f75b95a51807': `Додайте на панель Dock для зручного доступу та ширших можливостей.`,
'sfa6c42cdf48d93d2': `Але цей браузер не підтримує цю функцію. Щоб продовжити, відкрийте посилання в зовнішньому браузері.`,
'sfb78526365796a41': `Натисніть «Переглянути більше» в меню «Поділитися»`,
'sfea652f6580ff086': `Цей сайт має функції додатку.`,
    };
  